module.exports = __webpack_public_path__ + "images/category_lp/alcohol/new/assessment_achievements/2_34be577dd27720fc174aabaa1d75608a.png";